// CustomDropdownIndicator.js
import React from 'react';
import { components } from 'react-select';
import { useTheme } from '../../components/ThemeSwitcher/ThemeSwitcher';

// Reusable DropdownIndicator component
const CustomDropdownIndicator = (props) => {
  const {theme} = useTheme();
  const strokeColor = theme === "dark" ? "#fff" : "#343a40"; 
 
  return (
    <components.DropdownIndicator {...props}>
      {/* Inline SVG as the arrow */}
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' width="11" height="12">
        <path fill='none' stroke={strokeColor} strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='m2 5 6 6 6-6'/>
      </svg>
    </components.DropdownIndicator>
  );
};

export default CustomDropdownIndicator;
